import { ServiceStore } from "@intrasync/stores";
import { RouteType } from "types/RouteType";
// import HomeIcon from '@mui/icons-material/Home';

const dashboardRoute: RouteType[] = [
  {
    name: "Home",
    path: "/home",
    layout: "/app",
    viewportCard: {
      header: {
        title: "Dashboard",
        enableRefreshButton: true,
        component: () => import("./Dashboard.Header"),
      },
      body: {
        component: () => import("./Dashboard.Body"),
        grayBackground: true, // Add if needed
      },
    },
    group: 'Administration',
  requiresAuth: false, // Inferring based on requiresPermission being false
    requiresPermission: false,
    onEnter: ({ rootStore }) => {
      const accountsStore = rootStore?.accountsStore as ServiceStore;
      if (accountsStore) {
        accountsStore.find();
      }
    },
    dialogs: [
      {
        name: "AccountsListDialog",
        component: () => import("./Home.Body.AccountsSummaryList"),
        title: "Accounts List",
        cancelButton: true,
        height: 600,
      },
    ],
  },
];

export default dashboardRoute;
